module.exports = __webpack_public_path__ + "static/media/birthday.8ea7f5ea.svg";